import { atom } from 'recoil';

export const ShowSuggestPlaceDirectionState = atom({
    key: 'ShowSuggestPlaceDirectionState', 
    default: false, 
});